<template>
  <!--  @focusout="onFocusout" был внутри div -->
  <div
    class="base-dropdown-wrap"
    :class="[classes.root, { 'is-open': isOpen }]"
    @blur="isFocused = false"
  >
    <button
      ref="trigger"
      :class="['base-dropdown-wrap__trigger', classes.trigger]"
      aria-haspopup="true"
      :aria-expanded="isOpen"
      @click="isFocused = !isFocused"
    >
      <slot name="trigger">{{ text }}</slot>
    </button>

    <transition :name="transition">
      <div
        v-if="isOpen"
        class="base-dropdown-wrap__content"
        :class="[`base-dropdown-wrap__content--${position}`, classes.content]"
        @click="close"
      >
        <slot :on-item-click="isFocused"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'BaseDropdownBase',
  props: {
    /**
     * The toggle button text.
     */
    text: {
      type: String,
      default: '',
    },
    /**
     * Where the content should be placed in relation to the button.
     *
     * Options: 'bottom', 'top'
     */
    position: {
      type: String,
      default: 'bottom',
      validator(value) {
        return ['top', 'bottom'].includes(value)
      },
    },
    /**
     * The transition name.
     */
    transition: {
      type: String,
      default: 'base-dropdown-wrap--slide-up',
    },

    classes: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    isHovered: false,
    isFocused: false,
  }),

  computed: {
    isOpen() {
      return this.isHovered || this.isFocused
    },
  },

  methods: {
    onClickout(e) {
      if (!this.$el.contains(e.target)) this.isFocused = false
    },

    onFocusout(event) {
      if (!this.$el.contains(event.relatedTarget)) this.isFocused = false
    },

    close() {
      this.isHovered = false
      this.isFocused = false
    },
  },

  mounted() {
    const { onClickout } = this
    document.addEventListener('click', onClickout)
  },

  beforeUnmount() {
    document.removeEventListener('click', this.onClickout)
  },
}
</script>

<style>
/* Minimal styles */
.base-dropdown-wrap {
  display: inline-block;
  position: relative;
}

.base-dropdown-wrap__content {
  position: absolute;
  z-index: 5;
  min-width: 100%;
}

.base-dropdown-wrap__content--top {
  top: 0;
  transform: translateY(-100%);
}

/* Animation */
.base-dropdown-wrap--slide-up-enter-active,
.base-dropdown-wrap--slide-up-leave-active {
  transform: translateY(0);
  transition:
    0.5s ease opacity,
    0.5s ease transform;
}

.base-dropdown-wrap--slide-up-enter,
.base-dropdown-wrap--slide-up-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
